import Sprite from "../sprite/Sprite";

/**
 * @abstract
 */
export default class FixtureDescription {
    /**
     * @param {string} spriteName 
     * @param {boolean} traversable 
     * @param {boolean} opaque 
     * @param {boolean} stateSavable 
     */
    constructor(spriteName, traversable, opaque, stateSavable) {
        /**
         * @type {string}
         */
        this.spriteName = spriteName;
        /**
         * @type {boolean}
         */
        this.traversable = traversable;
        /**
         * @type {boolean}
         */
        this.opaque = opaque;
        /**
         * @type {boolean}
         */
        this.stateSavable = stateSavable;
        /**
         * This is lazily assigned (in CanvasView).
         * @type {Sprite}
         */
        this.sprite = null;
    }

}